export default "__VITE_ASSET__Dp48Xf$V__"